"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.url = exports.apiKey = void 0;
var url = '';
exports.url = url;
var apiKey = '';
exports.apiKey = apiKey;

if (window.location.hostname.includes('localhost') || window.location.hostname.includes('crescolabsdev')) {
  exports.url = url = 'https://api.crescolabs.com';
  exports.apiKey = apiKey = '73jjmpnQVc8JNX0JRMYH85DFkGQVxIXNf1Gfm6Bj';
} else {
  exports.url = url = 'https://x3wqo3qyra.execute-api.us-west-2.amazonaws.com/stage';
  exports.apiKey = apiKey = 'YAU0LT8LFsaqiVa40rlUCj8ASanm1sXB8IK6pRg0';
}